import { render, staticRenderFns } from "./marksEntry.vue?vue&type=template&id=6a2f2270&scoped=true&"
import script from "./marksEntry.vue?vue&type=script&lang=js&"
export * from "./marksEntry.vue?vue&type=script&lang=js&"
import style0 from "./marksEntry.vue?vue&type=style&index=0&id=6a2f2270&lang=scss&scoped=true&"
import style1 from "./marksEntry.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksEntry.vue?vue&type=style&index=2&id=6a2f2270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f2270",
  null
  
)

export default component.exports